/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetResourceTypeTreeParams,
  ResourceTypeCategory
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetResourceTypeTreeUrl = (params?: GetResourceTypeTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceType/GetResourceTypeTree?${stringifiedParams}` : `/api/ResourceType/GetResourceTypeTree`
}

export const getResourceTypeTree = async (params?: GetResourceTypeTreeParams, options?: RequestInit): Promise<EmptyTreeInfo> => {
  
  return customInstance<EmptyTreeInfo>(getGetResourceTypeTreeUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetResourceTypeTreeQueryKey = (params?: GetResourceTypeTreeParams,) => {
    return [
    `/api/ResourceType/GetResourceTypeTree`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetResourceTypeTreeQueryOptions = <TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceTypeTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceTypeTree>>> = ({ signal }) => getResourceTypeTree(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceTypeTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceTypeTree>>>
export type GetResourceTypeTreeQueryError = ErrorType<unknown>


export function useGetResourceTypeTree<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceTypeTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getResourceTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeTree<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getResourceTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeTree<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceTypeTree<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceTypeTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetResourceTypeTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceTypeTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceTypeTree>>> = ({ signal }) => getResourceTypeTree(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceTypeTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceTypeTree>>>
export type GetResourceTypeTreeSuspenseQueryError = ErrorType<unknown>


export function useGetResourceTypeTreeSuspense<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceTypeTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeTreeSuspense<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeTreeSuspense<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceTypeTreeSuspense<TData = Awaited<ReturnType<typeof getResourceTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetResourceTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceTypeTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetResourceTypeCategoriesUrl = () => {


  

  return `/api/ResourceType/GetResourceTypeCategories`
}

export const getResourceTypeCategories = async ( options?: RequestInit): Promise<ResourceTypeCategory[]> => {
  
  return customInstance<ResourceTypeCategory[]>(getGetResourceTypeCategoriesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetResourceTypeCategoriesQueryKey = () => {
    return [
    `/api/ResourceType/GetResourceTypeCategories`
    ] as const;
    }

    
export const getGetResourceTypeCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceTypeCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceTypeCategories>>> = ({ signal }) => getResourceTypeCategories({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceTypeCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceTypeCategories>>>
export type GetResourceTypeCategoriesQueryError = ErrorType<unknown>


export function useGetResourceTypeCategories<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceTypeCategories>>,
          TError,
          Awaited<ReturnType<typeof getResourceTypeCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeCategories<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceTypeCategories>>,
          TError,
          Awaited<ReturnType<typeof getResourceTypeCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeCategories<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceTypeCategories<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceTypeCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetResourceTypeCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceTypeCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceTypeCategories>>> = ({ signal }) => getResourceTypeCategories({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceTypeCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceTypeCategories>>>
export type GetResourceTypeCategoriesSuspenseQueryError = ErrorType<unknown>


export function useGetResourceTypeCategoriesSuspense<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeCategoriesSuspense<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceTypeCategoriesSuspense<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceTypeCategoriesSuspense<TData = Awaited<ReturnType<typeof getResourceTypeCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceTypeCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceTypeCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



